import React from "react";
import "./styles/MultiValueLabel.scss";

const MultiValueLabel = ({
  children,
  innerRef,
  innerProps,
  isFocused,
  ...props
}) => {
  const { origin, label, role } = props.data;

  return (
    <div
      className={`multiValue ${isFocused ? "isFocused" : ""}`}
      ref={innerRef}
      {...innerProps}
    >
      <div className="valueLabelContainer">
        <div className="valueLabel">
          <div className="label">
            <span className="labelName">{label}</span>
            <span className="labelRole">
              {role ? role : origin === "Prospect" ? "Proponente" : ""}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MultiValueLabel;
